export default "__VITE_ASSET__B6KI$FR7__"